import { render, staticRenderFns } from "./DetailWork.vue?vue&type=template&id=6cfebbca&scoped=true&"
import script from "./DetailWork.vue?vue&type=script&lang=js&"
export * from "./DetailWork.vue?vue&type=script&lang=js&"
import style0 from "./DetailWork.vue?vue&type=style&index=0&id=6cfebbca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfebbca",
  null
  
)

export default component.exports